import React from 'react'
import ProfileComp from '../../components/body/profile/ProfileComp'

const ProfileScreen = () => {
  return (
    <>
      <ProfileComp />
      
    </>
  )
}

export default ProfileScreen